import { format } from "date-fns";
import type { CSSProperties } from "react";

/**
 * Recharts renders SVG. Theme tokens are hex values, never wrap in hsl().
 * Uses --ink-2 for tick fill (stronger than --muted, good contrast in both themes).
 * Uses --hairline-strong for grid stroke (light/dark aware).
 */
export const CHART_TICK_FILL = "var(--ink-2)";

export const CHART_GRID_STROKE = "var(--hairline-strong)";

export const CHART_GRID_STROKE_OPACITY = 0.55;

export const chartTooltipContentStyle: CSSProperties = {
  backgroundColor: "var(--panel)",
  border: "1px solid var(--hairline-strong)",
  borderRadius: "8px",
  color: "var(--ink)",
  fontSize: "12px",
};

/**
 * X-axis label for a metrics series, granularity chosen by the selected range.
 *
 * Mirrors the client app's ResourceMetricsTab formatTimestamp. Lives here rather than beside a
 * chart component so every chart plotting the same axis - the Metrics tab and the Storage tab's
 * Disk I/O card - labels it identically.
 */
export function formatMetricsTimestamp(
  timestamp: string,
  rangeLabel: string,
): string {
  const date = new Date(timestamp);
  if (rangeLabel === "1H" || rangeLabel === "24H") {
    return format(date, "HH:mm");
  }
  if (rangeLabel === "7D" || rangeLabel === "30D") {
    return format(date, "MMM dd HH:mm");
  }
  return format(date, "MMM dd");
}
